import { supabase } from '../config/supabaseClient';

export async function fetchAddresses(firebaseUid) {
  const { data, error } = await supabase
    .from('addresses')
    .select('*')
    .eq('firebase_uid', firebaseUid)
    .order('is_default', { ascending: false })
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function addAddress(firebaseUid, address) {
  const { data, error } = await supabase
    .from('addresses')
    .insert({ firebase_uid: firebaseUid, ...address })
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateAddress(addressId, fields) {
  const { data, error } = await supabase
    .from('addresses')
    .update({ ...fields, updated_at: new Date().toISOString() })
    .eq('id', addressId)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteAddress(addressId) {
  const { error } = await supabase
    .from('addresses')
    .delete()
    .eq('id', addressId);
  if (error) throw error;
}

export async function setDefaultAddress(addressId, firebaseUid) {
  // First unset all defaults for this user
  await supabase
    .from('addresses')
    .update({ is_default: false })
    .eq('firebase_uid', firebaseUid);
  // Then set the new default
  return updateAddress(addressId, { is_default: true });
}